import { Reveal } from "@components/ui";
import starIcon from "@assets/images/Star-1.svg";

const GrayStar = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M8 1.5l1.854 3.756 4.146.603-3 2.924.708 4.13L8 10.88l-3.708 1.953.708-4.13-3-2.924 4.146-.603L8 1.5z"
      fill="#D9D9D9"
    />
  </svg>
);

const column1 = [
  {
    name: "Abdul Jabal",
    stars: 5,
    text: "GAZ connected our tower with zero delays. Professional, safe, and very responsive.",
  },
  {
    name: "Fatima Al Mazrouei",
    stars: 5,
    text: "Their emergency response saved our restaurant from a serious issue.",
  },
  {
    name: "Mohammed Hassan",
    stars: 4,
    text: "Reliable service and transparent billing. Very satisfied with the smart meter system.",
  },
];

const column2 = [
  {
    name: "Sara Ahmed",
    stars: 5,
    text: "The best billing system I've ever used. No surprises, just clean and clear charges.",
  },
  {
    name: "Omar Al Rashid",
    stars: 5,
    text: "Their emergency response saved our building from a potential gas leak.",
  },
  {
    name: "Khalid Ibrahim",
    stars: 4,
    text: "Great customer portal. Easy to manage everything online.",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-1">
      {Array.from({ length: 5 }, (_, i) =>
        i < count ? (
          <img key={i} src={starIcon} alt="star" className="w-4 h-4" />
        ) : (
          <GrayStar key={i} />
        )
      )}
    </div>
  );
}

function ReviewCard({ name, stars, text }: { name: string; stars: number; text: string }) {
  return (
    <div className="bg-white rounded-[24px] border border-[rgba(98,99,108,0.2)] py-5 px-6 hover:shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all duration-300">
      <div className="flex flex-col gap-1">
        <h4 className="text-[18px] md:text-[20px] font-semibold text-[#090d2c] tracking-[-0.04em] font-albert-sans">
          {name}
        </h4>
        <Stars count={stars} />
      </div>
      <p className="mt-3 text-[14px] md:text-[16px] lg:text-[18px] text-[rgba(10,14,46,0.75)] tracking-[-0.04em] font-albert-sans leading-[1.5]">
        {text}
      </p>
    </div>
  );
}

export function TestimonialsSection() {
  return (
    <section className="w-full bg-white py-12 md:py-16 lg:py-[120px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:items-center">
          {/* Left side */}
          <Reveal direction="up">
            <div className="flex flex-col gap-4">
              <h2 className="text-[28px] md:text-[36px] lg:text-[48px] tracking-[-0.04em] font-semibold text-[#122d63] font-albert-sans leading-[1.1]">
                Customer Reviews & Testimonials
              </h2>
              <p className="text-[20px] md:text-[24px] lg:text-[28px] tracking-[-0.04em] text-[#62636c] font-albert-sans leading-[1.4]">
                These are what our customers have to say about us
              </p>
            </div>
          </Reveal>

          {/* Right side — two columns of cards */}
          <Reveal direction="up" delay={100}>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="flex flex-col gap-4">
                {column1.map((review) => (
                  <ReviewCard key={review.name} {...review} />
                ))}
              </div>
              <div className="flex flex-col gap-4">
                {column2.map((review) => (
                  <ReviewCard key={review.name} {...review} />
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
